import { Injectable } from '@angular/core';
import { BaseService } from 'src/app/shared/services/base.service';
import { HttpClient } from '@angular/common/http';
import { ResultOfT, Result } from 'src/app/shared/models/response/result';
import { UserInfoResponseModel } from 'src/app/shared/models/response/userInfo-response-model';
import { UserInfoRequestModel } from 'src/app/shared/models/request/userInfo-request-model';
import { SearchRequestModel } from 'src/app/shared/models/request/search-request-model';
import { TherapistResponseModel } from 'src/app/shared/models/response/therapist/therapist-response-model';
import { PagedResponseModel } from 'src/app/shared/models/response/paged-response-model';
import { StateMasterResponseModel } from 'src/app/shared/models/common/state-master-response-model';
import {
  TherapistSetAvailabilityRequestModel,
  TherapistSetAvailabilityRequestModelSend
} from 'src/app/shared/models/response/therapist/therapist-availability-response-model';
import { TherapistCustomAvailabilityResponseModel } from 'src/app/shared/models/response/therapist/therapist-custom-availability-response-model';
import { EnumModel } from 'src/app/shared/models/common/enum-model';
import { HolidayResponse, TherapistAvailability } from 'src/app/shared/models/response/appointment/available-slots';
import { TherapistCustomDates } from 'src/app/shared/models/request/therapist/therapist-custom-dates';
import { TherapistCustomDatesResponseModel, TherapistEditBlockResponseModel } from 'src/app/shared/models/response/appointment/appointment-info-reponse-model';
import moment from 'moment';
import { TherapistContactInfoResponseModel, TherapistInfoModel } from 'src/app/shared/models/response/therapist/therapist-info-model';
import { SelectedTherapistResponseModel, TherapistDefaultFacilityModel } from 'src/app/shared/models/response/therapist/therapist-default-facility-model';
import { TherapistDeviceInfoModel } from 'src/app/shared/models/response/therapist/therapist-device-info-model';
import { TherapistLicenseInfoModel } from 'src/app/shared/models/response/therapist/therapist-licenseinfo-model';
import { TherapistOnlineMeetingModel, TherapistOnlineMeetingResponseModel } from 'src/app/shared/models/response/therapist/therapist-onlinemeeting-model';
import { WebStorageService } from '../../shared/services/web-storage.service';
import {
  LinkedTherapistWithCurrentFacilitiesRequestModel,
  LinkedTherapistWithCurrentFacilitiesResponseModel
} from 'src/app/shared/models/response/facility/facility-response-model';
import { TherapistClassificationInfoModel } from 'src/app/shared/models/response/therapist/therapist-classificationinfo-model';
import { TherapistGroupAppointmentInfo } from 'src/app/shared/models/response/therapist/therapist-group-appointment-setting';

@Injectable({
  providedIn: 'root'
})
export class AdminTherapistService extends BaseService {
  constructor(httpService: HttpClient, webStorageService: WebStorageService) {
    super(httpService, webStorageService);
  }
  getTherapists() {
    return this.get<ResultOfT<UserInfoResponseModel[]>>('Therapist/GetAllTherapist');
  }

  getAllTherapist(searchRequestModel: SearchRequestModel, isRefresh: boolean) {
    var url = 'Therapist/GetPagedTherapists';
    url = url + '?SortByColumnName=' + searchRequestModel.SortByColumnName;

    if (searchRequestModel.appUserInfoId) {
      url = url + '&appUserInfoId=' + searchRequestModel.appUserInfoId;
    }
    if (searchRequestModel.crmBranchId) {
      url = url + '&crmBranchId=' + searchRequestModel.crmBranchId;
    }

    if (searchRequestModel.SortOrder) {
      url = url + '&SortOrder=' + searchRequestModel.SortOrder;
    }

    if (searchRequestModel.PageSize) {
      url = url + '&PageSize=' + searchRequestModel.PageSize;
    }
    if (searchRequestModel.CurrentPageIndex) {
      url = url + '&CurrentPageIndex=' + searchRequestModel.CurrentPageIndex;
    }
    if (searchRequestModel.searchFromDate) {
      let datepass = moment(searchRequestModel.searchFromDate).format('MM-DD-YYYY');
      url = url + '&SearchFromDate=' + datepass;
    }
    if (searchRequestModel.searchToDate) {
      let datepass = moment(searchRequestModel.searchToDate).format('MM-DD-YYYY');
      url = url + '&searchToDate=' + datepass;
    }

    if (isRefresh) {
      url = url + '&rnd=' + Math.random().toString();
    }

    if (searchRequestModel.dictionaryFilter) {
      for (let key in searchRequestModel.dictionaryFilter) {
        let value = searchRequestModel.dictionaryFilter[key];
        if (value) {
          url = url + '&' + key + '=' + value;
        }
      }
    }
    return this.get<ResultOfT<PagedResponseModel<TherapistResponseModel>>>(url);
  }

  getTherapistById(therapistId: string) {
    return this.get<ResultOfT<UserInfoResponseModel>>('Therapist/GetTherapist/' + therapistId);
  }

  GetStates() {
    return this.get<ResultOfT<StateMasterResponseModel[]>>('Therapist/GetStates');
  }

  addTherapist(newtherapist: UserInfoResponseModel) {
    return this.post<ResultOfT<number>>('Therapist/AddTherapist', newtherapist);
  }

  updateTherapist(updatedTherapist: UserInfoResponseModel) {
    return this.post<ResultOfT<boolean>>('Therapist/UpdateTherapist', updatedTherapist);
  }

  removeTherapist(therapistId: string) {
    return this.get<ResultOfT<boolean>>('Therapist/ActiveInactive/' + therapistId + '/' + false);
  }

  getTherapistAvailability(therapistId: number) {
    return this.get<ResultOfT<TherapistSetAvailabilityRequestModel>>('Therapist/GetTherapistAvailability/' + therapistId);
  }

  setTherapistAvailability(newTherapistAvailability: TherapistSetAvailabilityRequestModelSend) {
    return this.post<ResultOfT<boolean>>('Therapist/SetTherapistAvailability', newTherapistAvailability);
  }

  updateTherapistAvailability(updateTherapistAvailability: TherapistSetAvailabilityRequestModelSend) {
    return this.post<ResultOfT<boolean>>('Therapist/UpdateTherapistAvailability', updateTherapistAvailability);
  }

  getDaysOfWeek() {
    return this.get<ResultOfT<EnumModel[]>>('Therapist/GetDaysOfWeek');
  }
  getEventSeries() {
    return this.get<ResultOfT<EnumModel[]>>('Therapist/GetRecurringType');
  }

  GetAvailData(Id: number, dt: string) {
    return this.get<ResultOfT<TherapistCustomDatesResponseModel[]>>('Therapist/GetAvailabilityForCalendar/' + Id + '/' + dt);
  }

  AddTherapistInfo(newtherapist: TherapistInfoModel) {
    return this.post<ResultOfT<number>>('Therapist/AddTherapistInfo', newtherapist);
  }
  AddTherapistDefaultFacility(newtherapist: TherapistDefaultFacilityModel) {
    return this.post<ResultOfT<boolean>>('Therapist/AddTherapistDefaultFacility', newtherapist);
  }
  AddTherapistLicenseInfo(newtherapist: TherapistLicenseInfoModel) {
    return this.post<ResultOfT<boolean>>('Therapist/AddTherapistLicenseInfo', newtherapist);
  }
  AddTherapistDeviceInfo(newtherapist: TherapistDeviceInfoModel) {
    return this.post<ResultOfT<boolean>>('Therapist/AddTherapistDeviceInfo', newtherapist);
  }
  AddTherapistonlineMeetingInfo(newtherapist: TherapistOnlineMeetingModel) {
    return this.post<ResultOfT<boolean>>('Therapist/AddTherapistonlineMeetingInfo', newtherapist);
  }
  UpdateTherapistInfo(updateTherapist: TherapistInfoModel) {
    return this.post<ResultOfT<boolean>>('Therapist/UpdateTherapistnfo', updateTherapist);
  }
  UpdateTherapistDefaultFacility(therapistDefaultFacilityModel: TherapistDefaultFacilityModel) {
    return this.post<ResultOfT<boolean>>('Therapist/UpdateTherapistDefaultFacility', therapistDefaultFacilityModel);
  }
  UpdateTherapistSelfScheduleAppointmentsStatus(therapistDefaultFacilityModel: TherapistDefaultFacilityModel) {
    return this.post<ResultOfT<boolean>>('Therapist/UpdateTherapistSelfScheduleAppointmentsStatus', therapistDefaultFacilityModel);
  }
  UpdateSelectedTherapistSelfScheduleAppointmentsStatus(selectedTherapistResponseModel: SelectedTherapistResponseModel) {
    return this.post<ResultOfT<boolean>>('Therapist/UpdateSelectedTherapistSelfScheduleAppointmentsStatus', selectedTherapistResponseModel);
  }
  GetAllLinkedFacilitiesWithCurrentTherapistDetails(LinkedFacilitiesWithCurrentTherapistRequestModel: LinkedTherapistWithCurrentFacilitiesRequestModel) {
    return this.post<ResultOfT<LinkedTherapistWithCurrentFacilitiesResponseModel[]>>(
      'Therapist/GetAllLinkedFacilitiesWithCurrentTharapistDetails',
      LinkedFacilitiesWithCurrentTherapistRequestModel
    );
  }
  UpdateTherapistLicenseInfo(newtherapist: TherapistLicenseInfoModel) {
    return this.post<ResultOfT<boolean>>('Therapist/UpdateTherapistLicenseInfo', newtherapist);
  }
  UpdateTherapistDeviceInfo(newtherapist: TherapistDeviceInfoModel) {
    return this.post<ResultOfT<boolean>>('Therapist/UpdateTherapistDeviceInfo', newtherapist);
  }
  UpdateTherapistonlineMeetingInfo(newtherapist: TherapistOnlineMeetingModel) {
    return this.post<ResultOfT<boolean>>('Therapist/UpdateTherapistonlineMeetingInfo', newtherapist);
  }

  ValidateZipcodeWithState(stateName: string, zipCode: number) {
    return this.get<ResultOfT<boolean>>('Therapist/ValidateZipcodeWithState/' + stateName + '/' + zipCode);
  }

  CheckTherapistAvailabilityOnDefaulFacility(therapistId: string, facilityId: string, dtDate: string) {
    return this.get<ResultOfT<boolean>>('Therapist/CheckTherapistAvailabilityOnDefaulFacility/' + therapistId + '/' + facilityId + '/' + dtDate);
  }
  ValidationToCheckTherapistLicensewithDefaultFacilityAndAvailiblity(therapistId: string, facilityId: string, dtDate: string, stateCode: string) {
    return this.get<ResultOfT<boolean>>(
      'Therapist/ValidationToCheckTherapistLicensewithDefaultFacilityAndAvailiblity/' + therapistId + '/' + facilityId + '/' + dtDate + '/' + stateCode
    );
  }

  GetTherapistGenertalEventLogs(searchRequestModel: SearchRequestModel) {
    var url = 'Therapist/GetTherapistGenertalEventLogs';
    url = url + '?appUserInfoId=' + searchRequestModel.enappUserInfoId;
    if (searchRequestModel.crmBranchId) {
      url = url + '&crmBranchId=' + searchRequestModel.crmBranchId;
    }
    if (searchRequestModel.SortByColumnName) {
      url = url + '&SortByColumnName=' + searchRequestModel.SortByColumnName;
    }
    if (searchRequestModel.SortOrder) {
      url = url + '&SortOrder=' + searchRequestModel.SortOrder;
    }

    if (searchRequestModel.PageSize) {
      url = url + '&PageSize=' + searchRequestModel.PageSize;
    }
    if (searchRequestModel.CurrentPageIndex) {
      url = url + '&CurrentPageIndex=' + searchRequestModel.CurrentPageIndex;
    }
    if (searchRequestModel.searchFromDate) {
      let datepass = moment(searchRequestModel.searchFromDate).format('MM-DD-YYYY');
      url = url + '&SearchFromDate=' + datepass;
    }
    if (searchRequestModel.searchToDate) {
      let datepass = moment(searchRequestModel.searchToDate).format('MM-DD-YYYY');
      url = url + '&searchToDate=' + datepass;
    }

    if (searchRequestModel.dictionaryFilter) {
      for (let key in searchRequestModel.dictionaryFilter) {
        let value = searchRequestModel.dictionaryFilter[key];
        if (value) {
          url = url + '&' + key + '=' + value;
        }
      }
    }
    return this.get<ResultOfT<PagedResponseModel<object>>>(url);
  }

  GetTherapistAvailabilityEventLogs(searchRequestModel: SearchRequestModel) {
    var url = 'Therapist/GetTherapistAvailabilityEventLogs';
    url = url + '?appUserInfoId=' + searchRequestModel.enappUserInfoId;
    if (searchRequestModel.crmBranchId) {
      url = url + '&crmBranchId=' + searchRequestModel.crmBranchId;
    }
    if (searchRequestModel.SortByColumnName) {
      url = url + '&SortByColumnName=' + searchRequestModel.SortByColumnName;
    }
    if (searchRequestModel.SortOrder) {
      url = url + '&SortOrder=' + searchRequestModel.SortOrder;
    }

    if (searchRequestModel.PageSize) {
      url = url + '&PageSize=' + searchRequestModel.PageSize;
    }
    if (searchRequestModel.CurrentPageIndex) {
      url = url + '&CurrentPageIndex=' + searchRequestModel.CurrentPageIndex;
    }
    if (searchRequestModel.searchFromDate) {
      let datepass = moment(searchRequestModel.searchFromDate).format('MM-DD-YYYY');
      url = url + '&SearchFromDate=' + datepass;
    }
    if (searchRequestModel.searchToDate) {
      let datepass = moment(searchRequestModel.searchToDate).format('MM-DD-YYYY');
      url = url + '&searchToDate=' + datepass;
    }

    if (searchRequestModel.dictionaryFilter) {
      for (let key in searchRequestModel.dictionaryFilter) {
        let value = searchRequestModel.dictionaryFilter[key];
        if (value) {
          url = url + '&' + key + '=' + value;
        }
      }
    }
    return this.get<ResultOfT<PagedResponseModel<object>>>(url);
  }

  AddUpdateTherapistClassificationInfo(newtherapist: TherapistClassificationInfoModel) {
    return this.post<ResultOfT<boolean>>('Therapist/AddUpdateTherapistClassificationInfo', newtherapist);
  }

  DeleteTherapistClassification(therapistClassificationInfoId: number[]) {
    const queryParams = therapistClassificationInfoId.map((id) => `therapistClassificationInfoId=${id}`).join('&');
    return this.get<ResultOfT<boolean>>(`Therapist/DeleteTherapistClassification?${queryParams}`);
  }

  DeleteTherapistCertification(therapistCertificationId: number) {
    return this.get<ResultOfT<boolean>>('Therapist/DeleteTherapistCertification/' + therapistCertificationId);
  }
  DeleteTherapistLicense(therapistLicenseInfoId: number) {
    return this.get<ResultOfT<boolean>>('Therapist/DeleteTherapistLicense/' + therapistLicenseInfoId);
  }

   AddTherapistGroupAppointmentSetting(settings: TherapistGroupAppointmentInfo) {
    return this.post<ResultOfT<boolean>>('Therapist/AddTherapistGroupAppointmentSetting', settings);
  }

}
